import React from "react";
import "./index.css";

const DownloadApp = () => (
  <div className="__appbgc" style={{ backgroundColor: '#0C9EA9', padding: '5rem 0' }}>
    <div className="container">
      <div className="row align-items-center">
        <div className="col-lg-7 col-md-7 text-white mb-4 mb-md-0">
          <span className="badge bg-light text-dark px-3 py-2 rounded-pill fw-semibold mb-3">MOBILE APP</span>
          <h2 className="display-6 fw-bold mb-3">Our Mobile App</h2>
          <p className="lead mb-4" style={{ opacity: 0.9 }}>
            A data collection platform with geofencing capabilities that ensures that data collected are of optimal accuracy and transparency.
          </p>
          <div className="d-flex flex-wrap gap-3">
            <a
              href="https://play.google.com/store/apps/details?id=com.eko.eko360"
              target="_blank"
              rel="noreferrer"
              className="btn btn-outline-light rounded-pill px-4 py-2 d-inline-flex align-items-center gap-2"
            >
              <i className="fab fa-google-play fs-5"></i>
              <span>Google Play Store</span>
            </a>
            <a
              href="https://apps.apple.com/us/app/eko360/id1581950732"
              target="_blank"
              rel="noreferrer"
              className="btn btn-outline-light rounded-pill px-4 py-2 d-inline-flex align-items-center gap-2"
            >
              <i className="fab fa-apple fs-5"></i>
              <span>Apple App Store</span>
            </a>
          </div>
        </div>
        <div className="col-lg-5 col-md-5 text-center">
          <img src="/assets/img/mobile-app.png" className="img-fluid" style={{ maxHeight: '380px' }} alt="Eko360 Mobile App Preview" />
        </div>
      </div>
    </div>
  </div>
);

export default DownloadApp;